import * as React from 'react'

export default ({ title, onClick }) => {

  return (
    <div className="files-thrower">
      <i className="far fa-share-from-square" title={title} onClick={onClick}></i>
    </div>
  )
}
